import {Injectable} from '@angular/core';
import {IParams} from "./iparams";

@Injectable({
  providedIn: 'root'
})
export class BaseEndpoint {

  constructor() {
  }

  static API_VERSION_1 = '/api/v1';
  static API_VERSION_2 = '/api/v2';
  static API_VERSION_3 = '/api/v3';

  static toParamString(params: IParams): string {
    let p: string = "";
    for (let key in params) {
      let value = params[key]
      if (value == null) continue
      if (p === '') p = p + '?'; else {
        p = p + '&';
      }
      p = p + key + '=' + this.convertToString(params[key])
    }
    return p
  }

  static convertToString(value: any) {
    if (value instanceof Date)
      return value.toISOString()
    return value.toString()
  }

}


